var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBookIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3726 13.7097H5.68029C4.32082 13.7097 3.21875 14.8118 3.21875 16.1713M17.3726 13.7097V17.402C17.3726 18.0818 16.8216 18.6328 16.1418 18.6328H5.68029C4.32082 18.6328 3.21875 17.5307 3.21875 16.1713M17.3726 13.7097V3.86358C17.3726 3.18385 16.8216 2.63281 16.1418 2.63281H7.21875M3.21875 16.1713V5.09435C3.21875 3.73488 4.32082 2.63281 5.68029 2.63281H7.21875M10.3435 6.32512H13.7188M10.3435 10.0174H13.7188M7.21875 13.6328V2.63281",
    stroke: "#5579F0",
    strokeWidth: 1.72331,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBookIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/BookIcon.722ece73.svg";
export { ForwardRef as ReactComponent };